import { Component, Renderer2, ElementRef, ViewChild, OnInit } from '@angular/core';

@Component({
  selector: 'app-examples',
  template: `
    <input type="file" (change)="onFileSelected($event)" accept="application/pdf"/>
    <div #pdfViewerContainer style="width: 60%; overflow-y: scroll;"></div>
  `,
  styles: [`
    canvas { width: 100%; border: 1px solid black; }
  `]
})
export class ExamplesComponent implements OnInit {
  @ViewChild('pdfViewerContainer', { static: true }) pdfContainer: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.loadPdfJs('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js');
  }

  loadPdfJs(src: string) {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onload = () => console.log('PDF.js loaded successfully');
    script.onerror = () => console.error('Error loading PDF.js');
    this.renderer.appendChild(document.head, script);
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        const typedArray = new Uint8Array(fileReader.result as ArrayBuffer);
        this.renderPDF(typedArray);
      };
      fileReader.readAsArrayBuffer(file);
    }
  }

  async renderPDF(pdfData: ArrayBuffer) {
    const loadingTask = (window as any).pdfjsLib.getDocument({data: pdfData});
    const pdf = await loadingTask.promise;
  
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = this.renderer.createElement('canvas');
      const ctx = canvas.getContext('2d');
  
      canvas.height = viewport.height;
      canvas.width = viewport.width;
  
      const renderContext = {
        canvasContext: ctx,
        viewport: viewport
      };
  
      await page.render(renderContext).promise;
      this.pdfContainer.nativeElement.appendChild(canvas);
  
      // Fetch and draw polygons
      const polygons = this.fetchJsonData(pageNum,viewport);
      polygons.forEach(pair => {
        const color = this.getRandomColor(); // Generate a unique color for each pair
        pair.forEach(polygon => this.drawBoundingBox(ctx, polygon.coords, color));
      });
    }
  }

  async renderPDFByURL(pdfURL: any) {
	
    const loadingTask = (window as any).pdfjsLib.getDocument(pdfURL);
    const pdf = await loadingTask.promise;
  
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = this.renderer.createElement('canvas');
      const ctx = canvas.getContext('2d');
  
      canvas.height = viewport.height;
      canvas.width = viewport.width;
  
      const renderContext = {
        canvasContext: ctx,
        viewport: viewport
      };
  
      await page.render(renderContext).promise;
      this.pdfContainer.nativeElement.appendChild(canvas);
  
      // Fetch and draw polygons
      const polygons = this.fetchJsonData(pageNum,viewport);
      polygons.forEach(pair => {
        const color = this.getRandomColor(); // Generate a unique color for each pair
        pair.forEach(polygon => this.drawBoundingBox(ctx, polygon.coords, color));
      });
    }
  }
  




convertInchesToPixels(polygon: number[],viewport:any) {
  const widthInPixels = 918;  // Example width in pixels
  const heightInPixels = 1188;  // Example height in pixels
  const widthInInches = 8.5;  // Example width in inches
  const heightInInches = 11;  // Example height in inches
  const xFactor = widthInPixels / widthInInches;
  const yFactor = heightInPixels / heightInInches;

  return polygon.map((value, index) => index % 2 === 0 ? value * xFactor : value * yFactor);
}

getRandomColor() {
  // Generate each color component in the range of 0 to 192 rather than 0 to 255
  // This change restricts the maximum brightness of the colors
  let r = Math.floor(Math.random() * 193);
  let g = Math.floor(Math.random() * 193);
  let b = Math.floor(Math.random() * 193);

  // Ensure at least one of the color components is less than 128 to generally keep colors darker
  const lowestValue = Math.floor(Math.random() * 3);
  if (lowestValue === 0) {
    r = Math.floor(Math.random() * 129);
  } else if (lowestValue === 1) {
    g = Math.floor(Math.random() * 129);
  } else {
    b = Math.floor(Math.random() * 129);
  }

  return `rgb(${r},${g},${b})`;  // Return RGB color string
}


drawBoundingBox(ctx: CanvasRenderingContext2D, coords: number[], color: string) {
  ctx.beginPath();
  ctx.lineWidth = 2;
  ctx.strokeStyle = color;  // Use the passed color
  ctx.moveTo(coords[0], coords[1]);
  for (let i = 2; i < coords.length; i += 2) {
    ctx.lineTo(coords[i], coords[i + 1]);
  }
  ctx.closePath();
  ctx.stroke();
}

fetchJsonData(pageNumber: number,viewport:any) {
  // Fetch or define your JSON structure here
  // This is a placeholder; replace it with actual data fetching logic or static data
  const jsonData =  {
    keyValuePairs: [
		{
			"key": {
				"content": "Patient Name:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2358,
							0.3009,
							4.948,
							0.3056,
							4.9472,
							0.4249,
							4.235,
							0.4202
						]
					}
				],
				"spans": [
					{
						"offset": 95,
						"length": 13
					}
				]
			},
			"value": {
				"content": "DASILVA, ROBERT",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.2719,
							0.3008,
							6.5278,
							0.3008,
							6.5278,
							0.4583,
							5.2719,
							0.4583
						]
					}
				],
				"spans": [
					{
						"offset": 109,
						"length": 15
					}
				]
			},
			"confidence": 0.874
		},
		{
			"key": {
				"content": "MRN:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2404,
							0.4965,
							4.5222,
							0.4965,
							4.5222,
							0.6016,
							4.2404,
							0.6016
						]
					}
				],
				"spans": [
					{
						"offset": 125,
						"length": 4
					}
				]
			},
			"value": {
				"content": "(FR)-013288912",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.2719,
							0.4918,
							6.098,
							0.4918,
							6.098,
							0.6159,
							5.2767,
							0.6254
						]
					}
				],
				"spans": [
					{
						"offset": 130,
						"length": 14
					}
				]
			},
			"confidence": 0.917
		},
		{
			"key": {
				"content": "Date of Birth:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2452,
							0.678,
							4.8994,
							0.678,
							4.8994,
							0.7973,
							4.2452,
							0.7973
						]
					}
				],
				"spans": [
					{
						"offset": 145,
						"length": 14
					}
				]
			},
			"value": {
				"content": "10/11/1928",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.2815,
							0.6732,
							5.8258,
							0.6732,
							5.8258,
							0.7925,
							5.2862,
							0.7925
						]
					}
				],
				"spans": [
					{
						"offset": 160,
						"length": 10
					}
				]
			},
			"confidence": 0.874
		},
		{
			"key": {
				"content": "Admit Date:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2452,
							0.8689,
							4.8278,
							0.8689,
							4.8278,
							0.9883,
							4.2452,
							0.9883
						]
					}
				],
				"spans": [
					{
						"offset": 171,
						"length": 11
					}
				]
			},
			"value": {
				"content": "1/30/2023",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.2862,
							0.8689,
							5.7781,
							0.8689,
							5.7781,
							0.9883,
							5.291,
							0.9835
						]
					}
				],
				"spans": [
					{
						"offset": 183,
						"length": 9
					}
				]
			},
			"confidence": 0.89
		},
		{
			"key": {
				"content": "Discharge Date:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2404,
							1.0503,
							5.0475,
							1.0503,
							5.0475,
							1.1888,
							4.2404,
							1.1888
						]
					}
				],
				"spans": [
					{
						"offset": 193,
						"length": 15
					}
				]
			},
			"confidence": 0.683
		},
		{
			"key": {
				"content": "Account Number:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2452,
							1.2413,
							5.1143,
							1.2413,
							5.1143,
							1.3607,
							4.2452,
							1.3607
						]
					}
				],
				"spans": [
					{
						"offset": 209,
						"length": 15
					}
				]
			},
			"value": {
				"content": "045810605-3030",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.2671,
							1.2413,
							6.1124,
							1.2365,
							6.1124,
							1.3607,
							5.2719,
							1.3607
						]
					}
				],
				"spans": [
					{
						"offset": 225,
						"length": 14
					}
				]
			},
			"confidence": 0.889
		},
		{
			"key": {
				"content": "Patient Type:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2405,
							1.4253,
							4.8971,
							1.437,
							4.8947,
							1.5712,
							4.2381,
							1.5595
						]
					}
				],
				"spans": [
					{
						"offset": 240,
						"length": 13
					}
				]
			},
			"value": {
				"content": "Inpatient",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.2671,
							1.4371,
							5.7112,
							1.4371,
							5.7112,
							1.5612,
							5.2719,
							1.5612
						]
					}
				],
				"spans": [
					{
						"offset": 254,
						"length": 9
					}
				]
			},
			"confidence": 0.891
		},
		{
			"key": {
				"content": "Attending:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2404,
							1.6233,
							4.7514,
							1.6233,
							4.7514,
							1.7474,
							4.2452,
							1.7426
						]
					}
				],
				"spans": [
					{
						"offset": 264,
						"length": 10
					}
				]
			},
			"value": {
				"content": "Rezapoor MD,Parisa",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.2671,
							1.6137,
							6.3129,
							1.6137,
							6.3129,
							1.7474,
							5.2671,
							1.7474
						]
					}
				],
				"spans": [
					{
						"offset": 275,
						"length": 18
					}
				]
			},
			"confidence": 0.884
		},
		{
			"key": {
				"content": "DOCUMENT NAME:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4871,
							2.2391,
							1.7716,
							2.2391,
							1.7716,
							2.3872,
							0.4871,
							2.3872
						]
					}
				],
				"spans": [
					{
						"offset": 312,
						"length": 14
					}
				]
			},
			"confidence": 0.326
		},
		{
			"key": {
				"content": "ELECTRONICALLY SIGNED BY:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4919,
							2.3967,
							2.5452,
							2.3967,
							2.5452,
							2.559,
							0.4919,
							2.559
						]
					}
				],
				"spans": [
					{
						"offset": 327,
						"length": 25
					}
				]
			},
			"value": {
				"content": "Singh MD,Atinderpal (2/2/2023 14:34 PST)",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							4.2404,
							2.4015,
							6.8955,
							2.4015,
							6.8955,
							2.5686,
							4.2404,
							2.5686
						]
					}
				],
				"spans": [
					{
						"offset": 371,
						"length": 40
					}
				]
			},
			"confidence": 0.256
		},
		{
			"key": {
				"content": "Patient:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4919,
							3.0651,
							1.0458,
							3.0603,
							1.041,
							3.2322,
							0.4919,
							3.2274
						]
					}
				],
				"spans": [
					{
						"offset": 439,
						"length": 8
					}
				]
			},
			"value": {
				"content": "DASILVA, ROBERT",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.1317,
							3.0603,
							2.5309,
							3.0603,
							2.5309,
							3.2322,
							1.1317,
							3.2322
						]
					}
				],
				"spans": [
					{
						"offset": 448,
						"length": 15
					}
				]
			},
			"confidence": 0.885
		},
		{
			"key": {
				"content": "Age:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4871,
							3.2561,
							0.8357,
							3.2513,
							0.8357,
							3.4184,
							0.4919,
							3.4184
						]
					}
				],
				"spans": [
					{
						"offset": 464,
						"length": 4
					}
				]
			},
			"value": {
				"content": "94 years",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.9312,
							3.2513,
							1.5472,
							3.2513,
							1.5472,
							3.4184,
							0.9312,
							3.4184
						]
					}
				],
				"spans": [
					{
						"offset": 469,
						"length": 8
					}
				]
			},
			"confidence": 0.885
		},
		{
			"key": {
				"content": "Sex:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.7669,
							3.2513,
							2.0963,
							3.2513,
							2.0963,
							3.4089,
							1.7669,
							3.4136
						]
					}
				],
				"spans": [
					{
						"offset": 478,
						"length": 4
					}
				]
			},
			"value": {
				"content": "Male",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.1393,
							3.2513,
							2.4879,
							3.2513,
							2.4879,
							3.3993,
							2.1393,
							3.4089
						]
					}
				],
				"spans": [
					{
						"offset": 483,
						"length": 4
					}
				]
			},
			"confidence": 0.917
		},
		{
			"key": {
				"content": "Associated Diagnoses:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4921,
							3.4221,
							2.0741,
							3.4375,
							2.0724,
							3.6128,
							0.4904,
							3.5974
						]
					}
				],
				"spans": [
					{
						"offset": 488,
						"length": 21
					}
				]
			},
			"value": {
				"content": "None",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.168,
							3.4375,
							2.5596,
							3.4375,
							2.5596,
							3.5951,
							2.168,
							3.5998
						]
					}
				],
				"spans": [
					{
						"offset": 510,
						"length": 4
					}
				]
			},
			"confidence": 0.89
		},
		{
			"key": {
				"content": "Author:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4966,
							3.6237,
							1.0219,
							3.6141,
							1.0219,
							3.7813,
							0.4966,
							3.7717
						]
					}
				],
				"spans": [
					{
						"offset": 515,
						"length": 7
					}
				]
			},
			"value": {
				"content": "Singh MD, Atinderpal",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.1222,
							3.6094,
							2.6694,
							3.6094,
							2.6694,
							3.786,
							1.1222,
							3.786
						]
					}
				],
				"spans": [
					{
						"offset": 523,
						"length": 20
					}
				]
			},
			"confidence": 0.874
		},
		{
			"key": {
				"content": "MRN:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							3.0132,
							3.0603,
							3.4191,
							3.0556,
							3.4239,
							3.2418,
							3.018,
							3.2418
						]
					}
				],
				"spans": [
					{
						"offset": 544,
						"length": 4
					}
				]
			},
			"value": {
				"content": "(FR)-013288912",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							3.4573,
							3.0556,
							4.5986,
							3.0508,
							4.6034,
							3.237,
							3.4621,
							3.2418
						]
					}
				],
				"spans": [
					{
						"offset": 549,
						"length": 14
					}
				]
			},
			"confidence": 0.916
		},
		{
			"key": {
				"content": "DOB:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.698,
							3.2418,
							3.1087,
							3.2418,
							3.1039,
							3.4041,
							2.6933,
							3.4041
						]
					}
				],
				"spans": [
					{
						"offset": 564,
						"length": 4
					}
				]
			},
			"value": {
				"content": "10/11/1928",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							3.1756,
							3.2418,
							3.9205,
							3.2465,
							3.9205,
							3.4136,
							3.1708,
							3.4041
						]
					}
				],
				"spans": [
					{
						"offset": 569,
						"length": 10
					}
				]
			},
			"confidence": 0.918
		},
		{
			"key": {
				"content": "FIN:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.0904,
							3.0556,
							5.3961,
							3.0556,
							5.3913,
							3.2274,
							5.0857,
							3.2274
						]
					}
				],
				"spans": [
					{
						"offset": 580,
						"length": 4
					}
				]
			},
			"value": {
				"content": "045810605-3030",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							5.4295,
							3.0556,
							6.5947,
							3.0556,
							6.5994,
							3.2322,
							5.4295,
							3.2274
						]
					}
				],
				"spans": [
					{
						"offset": 585,
						"length": 14
					}
				]
			},
			"confidence": 0.915
		},
		{
			"key": {
				"content": "Documentation By:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.6639,
							4.1565,
							1.7495,
							4.168,
							1.7456,
							4.5334,
							0.6601,
							4.5219
						]
					}
				],
				"spans": [
					{
						"offset": 631,
						"length": 17
					}
				]
			},
			"value": {
				"content": "Resident Physician.",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.0744,
							4.3518,
							2.4348,
							4.3465,
							2.4354,
							4.5232,
							1.0751,
							4.5285
						]
					}
				],
				"spans": [
					{
						"offset": 649,
						"length": 19
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "Admit Date:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8309,
							5.1133,
							1.7143,
							5.1133,
							1.7143,
							5.2756,
							0.8309,
							5.2756
						]
					}
				],
				"spans": [
					{
						"offset": 691,
						"length": 11
					}
				]
			},
			"value": {
				"content": "01/30/23 10:46",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.7669,
							5.1133,
							2.7888,
							5.1133,
							2.7888,
							5.2708,
							1.7669,
							5.2708
						]
					}
				],
				"spans": [
					{
						"offset": 703,
						"length": 14
					}
				]
			},
			"confidence": 0.874
		},
		{
			"key": {
				"content": "Discharge Disposition:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8261,
							5.2947,
							2.5213,
							5.2947,
							2.5213,
							5.4714,
							0.8261,
							5.4714
						]
					}
				],
				"spans": [
					{
						"offset": 718,
						"length": 22
					}
				]
			},
			"value": {
				"content": "Skilled nursing facility 03",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.5882,
							5.2852,
							4.2643,
							5.2852,
							4.2643,
							5.4714,
							2.5882,
							5.4714
						]
					}
				],
				"spans": [
					{
						"offset": 741,
						"length": 27
					}
				]
			},
			"confidence": 0.856
		},
		{
			"key": {
				"content": "Reason For Visit:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8309,
							5.4809,
							2.1059,
							5.4809,
							2.1059,
							5.6385,
							0.8309,
							5.6385
						]
					}
				],
				"spans": [
					{
						"offset": 769,
						"length": 17
					}
				]
			},
			"value": {
				"content": "SYNCOPE",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.1775,
							5.4809,
							2.8986,
							5.4809,
							2.8986,
							5.6337,
							2.1775,
							5.6385
						]
					}
				],
				"spans": [
					{
						"offset": 787,
						"length": 7
					}
				]
			},
			"confidence": 0.874
		},
		{
			"key": {
				"content": "Admitting Physician:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8357,
							5.6623,
							2.3829,
							5.6623,
							2.3829,
							5.8342,
							0.8357,
							5.8342
						]
					}
				],
				"spans": [
					{
						"offset": 795,
						"length": 20
					}
				]
			},
			"value": {
				"content": "Rezapoor MD, Parisa",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.4258,
							5.6623,
							3.9014,
							5.6623,
							3.9014,
							5.8342,
							2.4258,
							5.8342
						]
					}
				],
				"spans": [
					{
						"offset": 816,
						"length": 19
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "Attending Physician:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8309,
							5.8462,
							2.369,
							5.8509,
							2.3685,
							6.0251,
							0.8304,
							6.0204
						]
					}
				],
				"spans": [
					{
						"offset": 836,
						"length": 20
					}
				]
			},
			"value": {
				"content": "Rezapoor MD, Parisa",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.4211,
							5.8533,
							3.8966,
							5.8481,
							3.8972,
							6.0152,
							2.4217,
							6.0204
						]
					}
				],
				"spans": [
					{
						"offset": 857,
						"length": 19
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "Consulting Physician:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8309,
							6.0297,
							2.4645,
							6.0347,
							2.464,
							6.2044,
							0.8304,
							6.1994
						]
					}
				],
				"spans": [
					{
						"offset": 877,
						"length": 21
					}
				]
			},
			"value": {
				"content": "Rezapoor MD, Parisa",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.5118,
							6.0347,
							3.9825,
							6.0268,
							3.9834,
							6.1939,
							2.5127,
							6.2018
						]
					}
				],
				"spans": [
					{
						"offset": 899,
						"length": 19
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "Consulting Physician:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8309,
							6.2114,
							2.4593,
							6.2114,
							2.4593,
							6.3832,
							0.8309,
							6.3832
						]
					}
				],
				"spans": [
					{
						"offset": 919,
						"length": 21
					}
				]
			},
			"value": {
				"content": "IM Teaching, B",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.6264,
							6.2114,
							3.6388,
							6.2114,
							3.6388,
							6.3832,
							2.6264,
							6.3832
						]
					}
				],
				"spans": [
					{
						"offset": 944,
						"length": 14
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "Consulting Physician:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8309,
							6.3928,
							2.4645,
							6.3976,
							2.464,
							6.5719,
							0.8304,
							6.567
						]
					}
				],
				"spans": [
					{
						"offset": 959,
						"length": 21
					}
				]
			},
			"value": {
				"content": "Mu DO, Anandit M",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.507,
							6.3976,
							3.7295,
							6.3976,
							3.7295,
							6.5694,
							2.507,
							6.5694
						]
					}
				],
				"spans": [
					{
						"offset": 981,
						"length": 16
					}
				]
			},
			"confidence": 0.856
		},
		{
			"key": {
				"content": "Primary Care Physician:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8261,
							6.579,
							2.6216,
							6.579,
							2.6216,
							6.7556,
							0.8261,
							6.7556
						]
					}
				],
				"spans": [
					{
						"offset": 998,
						"length": 23
					}
				]
			},
			"value": {
				"content": "Montana MD, Anthony W",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							2.6646,
							6.579,
							4.3216,
							6.579,
							4.3216,
							6.7556,
							2.6646,
							6.7556
						]
					}
				],
				"spans": [
					{
						"offset": 1022,
						"length": 21
					}
				]
			},
			"confidence": 0.841
		},
		{
			"key": {
				"content": "Active/Final Diagnosis(es)",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.6639,
							6.9499,
							2.5658,
							6.9657,
							2.5642,
							7.151,
							0.6624,
							7.1352
						]
					}
				],
				"spans": [
					{
						"offset": 1044,
						"length": 26
					}
				]
			},
			"value": {
				"content": "Acidosis, unspecified Dehydration Hypotension, unspecified Sepsis, unspecified organism Syncope and collapse Urinary tract infection, site not specified",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.1604,
							7.3429,
							3.8346,
							7.3429,
							3.8346,
							8.441,
							1.1604,
							8.441
						]
					}
				],
				"spans": [
					{
						"offset": 1071,
						"length": 152
					}
				]
			},
			"confidence": 0.488
		},
		{
			"key": {
				"content": "Initial presentation:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8357,
							9.5735,
							2.3695,
							9.582,
							2.3685,
							9.7696,
							0.8347,
							9.7611
						]
					}
				],
				"spans": [
					{
						"offset": 1258,
						"length": 21
					}
				]
			},
			"value": {
				"content": "Patient is a 94-year-old male with past medical history of prostate cancer s/p radiation and TURP, hypertension, hyperlipidemia, COPD and hypothyroidism who was recently admitted to the",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.8213,
							9.7826,
							7.989,
							9.7826,
							7.989,
							10.174,
							0.8213,
							10.174
						]
					}
				],
				"spans": [
					{
						"offset": 1280,
						"length": 185
					}
				]
			},
			"confidence": 0.683
		},
		{
			"key": {
				"content": "Printed Date/Time:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4871,
							10.3252,
							1.4522,
							10.3292,
							1.4517,
							10.4597,
							0.4866,
							10.4557
						]
					}
				],
				"spans": [
					{
						"offset": 1466,
						"length": 18
					}
				]
			},
			"value": {
				"content": "2/2/2023 18:54 EST",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.5226,
							10.3274,
							2.5213,
							10.322,
							2.522,
							10.4557,
							1.5233,
							10.4611
						]
					}
				],
				"spans": [
					{
						"offset": 1485,
						"length": 18
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "Report Request ID:",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							0.4871,
							10.5178,
							1.4756,
							10.5178,
							1.4756,
							10.6467,
							0.4871,
							10.6467
						]
					}
				],
				"spans": [
					{
						"offset": 1504,
						"length": 18
					}
				]
			},
			"value": {
				"content": "324944268",
				"boundingRegions": [
					{
						"pageNumber": 1,
						"polygon": [
							1.5281,
							10.5178,
							2.0916,
							10.513,
							2.0916,
							10.6419,
							1.5281,
							10.6467
						]
					}
				],
				"spans": [
					{
						"offset": 1523,
						"length": 9
					}
				]
			},
			"confidence": 0.874
		},
		{
			"key": {
				"content": "Patient Name:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2358,
							0.3009,
							4.948,
							0.3056,
							4.9472,
							0.4249,
							4.235,
							0.4202
						]
					}
				],
				"spans": [
					{
						"offset": 1628,
						"length": 13
					}
				]
			},
			"value": {
				"content": "DASILVA, ROBERT",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							5.2719,
							0.3008,
							6.5278,
							0.3008,
							6.5278,
							0.4583,
							5.2719,
							0.4583
						]
					}
				],
				"spans": [
					{
						"offset": 1642,
						"length": 15
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "MRN:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2404,
							0.4965,
							4.5222,
							0.4965,
							4.5222,
							0.6016,
							4.2404,
							0.6016
						]
					}
				],
				"spans": [
					{
						"offset": 1658,
						"length": 4
					}
				]
			},
			"value": {
				"content": "(FR)-013288912",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							5.2719,
							0.4918,
							6.098,
							0.4918,
							6.098,
							0.6159,
							5.2767,
							0.6254
						]
					}
				],
				"spans": [
					{
						"offset": 1663,
						"length": 14
					}
				]
			},
			"confidence": 0.908
		},
		{
			"key": {
				"content": "Date of Birth:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2452,
							0.678,
							4.8994,
							0.678,
							4.8994,
							0.7973,
							4.2452,
							0.7973
						]
					}
				],
				"spans": [
					{
						"offset": 1678,
						"length": 14
					}
				]
			},
			"value": {
				"content": "10/11/1928",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							5.2815,
							0.6732,
							5.8258,
							0.6732,
							5.8258,
							0.7925,
							5.2862,
							0.7925
						]
					}
				],
				"spans": [
					{
						"offset": 1693,
						"length": 10
					}
				]
			},
			"confidence": 0.862
		},
		{
			"key": {
				"content": "Admit Date:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2452,
							0.8689,
							4.8278,
							0.8689,
							4.8278,
							0.9883,
							4.2452,
							0.9883
						]
					}
				],
				"spans": [
					{
						"offset": 1704,
						"length": 11
					}
				]
			},
			"value": {
				"content": "1/30/2023",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							5.2862,
							0.8689,
							5.7781,
							0.8689,
							5.7781,
							0.9883,
							5.291,
							0.9835
						]
					}
				],
				"spans": [
					{
						"offset": 1716,
						"length": 9
					}
				]
			},
			"confidence": 0.885
		},
		{
			"key": {
				"content": "Discharge Date:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2404,
							1.0503,
							5.0475,
							1.0503,
							5.0475,
							1.1888,
							4.2404,
							1.1888
						]
					}
				],
				"spans": [
					{
						"offset": 1726,
						"length": 15
					}
				]
			},
			"confidence": 0.649
		},
		{
			"key": {
				"content": "Account Number:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2404,
							1.2413,
							5.1096,
							1.2413,
							5.1096,
							1.3607,
							4.2404,
							1.3607
						]
					}
				],
				"spans": [
					{
						"offset": 1742,
						"length": 15
					}
				]
			},
			"value": {
				"content": "045810605-3030",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							5.2671,
							1.2413,
							6.1171,
							1.2365,
							6.1171,
							1.3607,
							5.2719,
							1.3607
						]
					}
				],
				"spans": [
					{
						"offset": 1758,
						"length": 14
					}
				]
			},
			"confidence": 0.885
		},
		{
			"key": {
				"content": "Patient Type:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2405,
							1.4272,
							4.8916,
							1.4357,
							4.8899,
							1.5697,
							4.2387,
							1.5611
						]
					}
				],
				"spans": [
					{
						"offset": 1773,
						"length": 13
					}
				]
			},
			"value": {
				"content": "Inpatient",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							5.2671,
							1.4418,
							5.7112,
							1.4371,
							5.7112,
							1.5612,
							5.2719,
							1.5612
						]
					}
				],
				"spans": [
					{
						"offset": 1787,
						"length": 9
					}
				]
			},
			"confidence": 0.885
		},
		{
			"key": {
				"content": "Attending:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							4.2404,
							1.6233,
							4.7466,
							1.6233,
							4.7466,
							1.7474,
							4.2452,
							1.7426
						]
					}
				],
				"spans": [
					{
						"offset": 1797,
						"length": 10
					}
				]
			},
			"value": {
				"content": "Rezapoor MD,Parisa",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							5.2671,
							1.6137,
							6.3129,
							1.6137,
							6.3129,
							1.7474,
							5.2671,
							1.7474
						]
					}
				],
				"spans": [
					{
						"offset": 1808,
						"length": 18
					}
				]
			},
			"confidence": 0.877
		},
		{
			"key": {
				"content": "Printed Date/Time:",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							0.4871,
							10.3268,
							1.4469,
							10.3268,
							1.4469,
							10.4605,
							0.4871,
							10.4605
						]
					}
				],
				"spans": [
					{
						"offset": 4996,
						"length": 18
					}
				]
			},
			"value": {
				"content": "2/2/2023 18:54 EST",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							1.5281,
							10.3268,
							2.5213,
							10.3268,
							2.5213,
							10.4557,
							1.5281,
							10.4557
						]
					}
				],
				"spans": [
					{
						"offset": 5015,
						"length": 18
					}
				]
			},
			"confidence": 0.859
		},
		{
			"key": {
				"content": "Report Request",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							0.4871,
							10.5178,
							1.275,
							10.5178,
							1.275,
							10.6467,
							0.4871,
							10.6467
						]
					}
				],
				"spans": [
					{
						"offset": 5034,
						"length": 14
					}
				]
			},
			"value": {
				"content": "324944268",
				"boundingRegions": [
					{
						"pageNumber": 2,
						"polygon": [
							1.5233,
							10.5178,
							2.0916,
							10.513,
							2.0916,
							10.6419,
							1.5281,
							10.6467
						]
					}
				],
				"spans": [
					{
						"offset": 5053,
						"length": 9
					}
				]
			},
			"confidence": 0.358
		}
	]
  };

    // Filter key-value pairs by pageNumber, and check for undefined key and value
    return jsonData.keyValuePairs.filter(pair => 
      pair.key && pair.value &&
      pair.key.boundingRegions.some(region => region.pageNumber === pageNumber) &&
      pair.value.boundingRegions.some(region => region.pageNumber === pageNumber)
    ).map(pair => [
      { coords: this.convertInchesToPixels(pair.key.boundingRegions[0].polygon,viewport) },
      { coords: this.convertInchesToPixels(pair.value.boundingRegions[0].polygon,viewport) }
    ]);
}

}
